<agr-wrapper-site-sidenav [navigationItems]="navigationItems" data-test="site-root">
  <router-outlet></router-outlet>
</agr-wrapper-site-sidenav>

<app-orderplanning-customer-selection-custom-config></app-orderplanning-customer-selection-custom-config>
